const DEFAULT_PUBLIC_USER_NAME = 'Пользователь';
const EMAIL_MARKER = '@';

export const isEmailLike = (value) => (
  typeof value === 'string' && value.includes(EMAIL_MARKER)
);

export const safePublicText = (value) => {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  return trimmed && !isEmailLike(trimmed) ? trimmed : '';
};

export const safeUsername = (profile) => safePublicText(profile?.username);

export const publicUserName = (profile, fallback = DEFAULT_PUBLIC_USER_NAME) => (
  safePublicText(profile?.displayName)
  || safePublicText(profile?.name)
  || safeUsername(profile)
  || [profile?.firstName, profile?.lastName].map(safePublicText).filter(Boolean).join(' ')
  || (profile?.id || profile?.userId ? `${fallback} #${profile.id || profile.userId}` : fallback)
);

export const publicUserInitial = (profile, fallback = DEFAULT_PUBLIC_USER_NAME) => (
  publicUserName(profile, fallback).slice(0, 1).toUpperCase()
);
